import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TheatersIcon(props: IconProps) {
    return <Icon {...props} iconKey={"theaters"}/>
}
